import { useEffect } from 'react'
import Box from '@mui/material/Box'
import { useSelector, useDispatch } from 'react-redux'
import { HideInMobileBox } from 'components/common/Hidden'
import NavButton from './NavButton'
import {
  selectNavbarClicked,
  setNavbarClicked,
} from 'store/pageLoad/pageLoadSlice'
import { debounce } from 'lodash-es'
import { GtmAgent } from 'utils/hooks/analytics'

const NavButtonList = ({
  catalogs,
  onCatalogOrSubMenuClick,
  onServiceClassificationClick,
}) => {
  const dispatch = useDispatch()

  const navbarClicked = useSelector(selectNavbarClicked)

  useEffect(() => {
    const mousemoveEvent = debounce(() => {
      if (navbarClicked) dispatch(setNavbarClicked(false))
    }, 100)
    window.addEventListener('mousemove', mousemoveEvent)

    return () => {
      window.removeEventListener('mousemove', mousemoveEvent)
    }
  }, [navbarClicked])

  return (
    <HideInMobileBox display="flex">
      <Box mr={4.5} />
      {catalogs?.map((catalog, index) => {
        return (
          <NavButton
            key={'catalog-' + index}
            navbarClicked={navbarClicked}
            navContent={
              catalog?.subcatalogs?.some(
                (subcatalog) => subcatalog?.items.length > 0
              ) ||
              catalog?.subMenus?.some(
                (subMenu) => subMenu?.subcatalogs?.length > 0
              )
                ? catalog
                : ''
            }
            onCatalogOrSubMenuClick={onCatalogOrSubMenuClick}
            onServiceClassificationClick={onServiceClassificationClick}
          >
            <div
              onClick={() => {
                GtmAgent.directSendToGTM({
                  event: 'living_action',
                  living_event_name: 'headermenu_click',
                  living_click_name: catalog?.name,
                  living_click_location: 'web_主選單',
                  ...(catalog?._id && { living_click_id: catalog._id }),
                })

                if (catalog.link && catalog.menuType !== 'mainWithSub') {
                  dispatch(setNavbarClicked(true))
                  onCatalogOrSubMenuClick(catalog)
                }
              }}
            >
              {catalog.name}
            </div>
          </NavButton>
        )
      })}
    </HideInMobileBox>
  )
}

export default NavButtonList
